import { gql } from '@apollo/client';

export interface SupportLoginShortCodeGenerationLogType {
    id: number;
    operatorAccountId: number;
    operatorAppRole: string;
    operatorPhone: number | null;
    operatorAccountName: string | null;
    targetAccountId: number;
    targetAccountRole: string;
    targetPhone: number | null;
    targetAccountName: string | null;
    shortCode: string;
    isUsed: boolean;
    usedAt: number | null;
    createdAt: number | null;
}

export interface SupportLoginShortCodeGenerationLogPageFilterInput {
    operatorAccountId?: number | null;
    operatorPhone?: number | null;
    targetAccountId?: number | null;
    targetPhone?: number | null;
    createdAtStart?: number | null;
    createdAtEnd?: number | null;
}

export interface SupportLoginShortCodeGenerationLogPageRequestInput {
    page?: number;
    size?: number;
}

export interface SupportLoginShortCodeGenerationLogPageResponse {
    content: SupportLoginShortCodeGenerationLogType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

export interface GetSupportLoginShortCodeGenerationLogPageResponse {
    getSupportLoginShortCodeGenerationLogPage: SupportLoginShortCodeGenerationLogPageResponse;
}

export interface GetSupportLoginShortCodeGenerationLogPageVariables {
    filter?: SupportLoginShortCodeGenerationLogPageFilterInput | null;
    pageRequest?: SupportLoginShortCodeGenerationLogPageRequestInput | null;
}

export const GET_SUPPORT_LOGIN_SHORT_CODE_GENERATION_LOG_PAGE = gql`
    query GetSupportLoginShortCodeGenerationLogPage(
        $filter: SupportLoginShortCodeGenerationLogPageFilterInput
        $pageRequest: SupportLoginShortCodeGenerationLogPageRequestInput
    ) {
        getSupportLoginShortCodeGenerationLogPage(filter: $filter, pageRequest: $pageRequest) {
            content {
                id
                operatorAccountId
                operatorAppRole
                operatorPhone
                operatorAccountName
                targetAccountId
                targetAccountRole
                targetPhone
                targetAccountName
                shortCode
                isUsed
                usedAt
                createdAt
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;
